module.exports = __webpack_public_path__ + "img/Publish (Active).66d002b6.svg";